import columnResizeToolSettings from './column-resize';

export default {
  columnResizeToolSettings,
};
